<template>
  <div class="content_wrap">
    <div
      :class="['empty', 'flex-middle', 'flex-column']"
      :style="{ background: setBgColor }"
      v-if="emptyState"
    >
      <div class="flex-column align-center" v-if="emptyState === 'loading'">
        <div class="loader" />
        <div class="empty_text">{{ getEmptyData().emptyText }}</div>
      </div>
      <template v-else>
        <img :src="emptyIcon[emptyState]" class="icon_img" />
        <div class="empty_text">{{ getEmptyData().emptyText }}</div>
        <div
          v-if="!/^(loading|null)$/.test(emptyState)"
          style="margin-top: 20px"
        >
          <!-- <button
            class="mr-20 close_btn"
            type="default"
            size="mini"
            @click="closeEmpty"
          >
            {{ "取消" }}
          </button> -->
          <button class="mini_btn" type="primary" size="mini" @click="reload">
            {{ getEmptyData().btnText }}
          </button>
        </div>
        <div v-if="errMsg" class="errMsg">{{ errMsg }}</div>
      </template>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import emptyIcon from "@/utils/emptyIcon.js";

export default {
  props: {
    uid: {
      type: String,
      default: ''
    },
    state: {
      type: String | Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {},
  data() {
    return {
      emptyIcon,
      emptyState: false,
      emptyText: '',
      errMsg: undefined,
      service: undefined,
    }
  },
  computed: {
    ...mapState(["requestFailureArr"]),
    getEmptyData() {
      return () => {
        switch (this.emptyState) {
          case 'loading': { this.errMsg = undefined; return { emptyText: '加载中...' } }
          case 'null': return { emptyText: this.emptyText || '暂无数据' }
          case 'token': return { emptyText: '登录过期，请重新登录', btnText: '登录过期' }
          case 'loginFailed': return { emptyText: '登录失败，请切换Wi-Fi或移动数据后重试', btnText: '重试' }
          case 'timeout': return { emptyText: '网络请求超时，请检查网络后重试', btnText: '重试' }
          case 'wechat': return { emptyText: "网络中断，请检查网络后重试", btnText: '重试' }
          default: { this.emptyState = false; this.errMsg = undefined; this.emptyText = '' }
        }
      }
    },
    setBgColor() {
      return this.emptyState === 'loading' ? 'transparent' : this.bgColor
    },
  },
  watch: {
    requestFailureArr: {
      deep: true,
      handler(val) {
        console.log('组件中的对象', val)
        if (val[this.uid]) {
          if (val[this.uid].length) {
            let arr = val[this.uid]
            this.emptyState = arr[0].errType
            this.errMsg = arr[0].errMsg
            this.service = arr[0].options.service
          } else {
            this.emptyState = false
          }
        }
      }
    },
  },
  methods: {
    reload() {
      let arr = this.requestFailureArr[this.uid]
      this.closeEmpty()
      arr.forEach(item => {
        this.service(item.options)
      })
    },
    closeEmpty() {
      this.emptyState = false
      this.$store.commit('setRequestFailureArr', { options: null, errType: false, errMsg: undefined, uid: this.uid })
    }
  },
  destroyed() {
    this.closeEmpty()
  }
}
</script>
<style lang='less' scoped>
@keyframes empty {
  100% {
    transform: rotate(1turn);
  }
}
.content_wrap {
  position: relative;
  min-height: 230px;
}
.empty {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  .loader {
    --d: 22px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    color: #80b1fa;
    margin-bottom: 50px;
    box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
      calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 1px,
      calc(0 * var(--d)) calc(1 * var(--d)) 0 2px,
      calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 3px,
      calc(-1 * var(--d)) calc(0 * var(--d)) 0 4px,
      calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 5px,
      calc(0 * var(--d)) calc(-1 * var(--d)) 0 6px;
    animation: empty 1s infinite steps(8);
  }
  .icon_img {
    width: 6.5%;
    min-width: 90px;
    max-width: 105px;
    margin-bottom: 23px;
  }
  .empty_text {
    font-size: 14px;
    color: #2d2d2d;
  }
  .close_btn,
  .mini_btn {
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    padding: 0 15px;
    border-radius: 16px;
    box-sizing: border-box;
    background-color: #d6dff8;
    cursor: pointer;
  }
  .close_btn {
    border: 1px solid #888;
    color: #888;
    background: #fff;
  }
  .mini_btn {
    border: 1px solid #2223eb;
    color: #2223eb;
  }
  .errMsg {
    width: 93%;
    background: #e4e4e4;
    max-height: 50%;
    border-radius: 12px;
    margin-top: 10px;
    overflow: auto;
    padding: 12px;
    font-size: 13px;
    color: #292929;
  }
}
</style>